import React, { createContext, useCallback, useContext, useState } from "react";
import ReserveModal from "../components/ReserveModal";

const ReserveContext = createContext({ open: () => {}, close: () => {} });

export const ReserveProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => setIsOpen(false), []);
    return (
        <ReserveContext.Provider value={{ open, close, isOpen }}>
            {children}
            <ReserveModal open={isOpen} onClose={close} />
        </ReserveContext.Provider>
    );
};

export const useReserve = () => useContext(ReserveContext);
